/* ------------------------------------------------------------------------
Copyright (c) 2016, VoiceVibes, Inc

VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
All contents of this file are proprietary and confidential. No part of
any of the contents of this file may be disclosed in any manner to
a third party without the prior written consent of VoiceVibes, Inc.
Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

<template>
  <div>
    <label
      class="how-many-speakers lower"
      style="font-size: 14px"
    >
      How Many Speakers in This Recording?
    </label>

    <label
      class="radioLabel"
    >
      <input
        id="algo-default"
        v-model="algorithm"
        type="radio"
        value="default"
        @change="algorithmChosen"
      >
      One Speaker
    </label>
    <label
      class="radioLabel"
    >
      <input
        id="algo-convo"
        v-model="algorithm"
        type="radio"
        value="conversational"
        @change="algorithmChosen"
      >
      Multi-Speaker
    </label>
    <br>
  </div>
</template>

<style lang="less" scoped>
  .how-many-speakers {
    font-size: 14px;
    font-weight: 600;
  }
  .icon-file {
    width: 18px;
    height: 18px;
  }
  .radioLabel {
    padding: 2px 0;
    display: block;
    font-size: 14px;
    font-weight: 400;
  }
  .algorithm-selection {
    width: 80%;
  }
</style>
<script>

export default {
  data() {
    return {
      algorithm: 'default',
      checkboxValue: 'left',
      userErrors: false,
      selected: null,
      // TODO: Make screenreader stuff work
      screenAssignments: [],
      screenReader: null,
    };
  },
  mounted() {
    // Publish the default algo to parent components
    this.algorithmChosen();
  },
  methods: {
    algorithmChosen() {
      const algorithms = this.$store.getters.org.algorithmConfig.algorithms;

      let algorithm;
      algorithms.forEach((algo) => {
        if (algo.name.indexOf(this.algorithm) !== -1) {
          // Choose the correct algorithm, v3-default, v4-conversational, etc.
          algorithm = algo.name;
        }
      });

      this.$emit('algorithmChosen', {
        algorithm,
      });
    },
  }
};
</script>
